import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: JSX.Element;
  adminOnly?: boolean;
}

export default function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const [status, setStatus] = useState<'loading' | 'auth' | 'unauth' | 'forbidden'>('loading');

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    const role = localStorage.getItem('userRole');

    if (!isAuthenticated) {
      setStatus('unauth');
    } else if (adminOnly && role !== 'admin') {
      setStatus('forbidden');
    } else {
      setStatus('auth');
    }
  }, [adminOnly]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (status === 'unauth') {
    return <Navigate to="/login" replace />;
  }

  if (status === 'forbidden') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <i className="ri-lock-line text-5xl text-gray-400"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">アクセス権限がありません</h2>
          <p className="text-sm text-gray-500 mb-6">このページは管理者のみアクセスできます。</p>
          <a
            href="/"
            className="inline-block px-6 py-2 bg-gray-900 text-white text-sm rounded-lg hover:bg-gray-700 transition-all cursor-pointer whitespace-nowrap"
          >
            ホームへ戻る
          </a>
        </div>
      </div>
    );
  }

  return children;
}
